import dayjs from "dayjs";

export const transformDate = (dateEntry: string) => {
  const date = dayjs(dateEntry);
  const currentTime = dayjs().format("HH:mm:ss");
  return date.format("YYYY-MM-DD") + " " + currentTime;
};
